export const getAddMeasureModalSteps = (t) => [
    {
        target: '[data-tour="amm-modal"]',
        placement: 'center',
        title: t('tour.addMeasureModal.step-welcome-title'),
        content: t('tour.addMeasureModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="amm-date"]',
        title: t('tour.addMeasureModal.step-date-title'),
        content: t('tour.addMeasureModal.step-date-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="amm-bmi"]',
        title: t('tour.addMeasureModal.step-bmi-title'),
        content: t('tour.addMeasureModal.step-bmi-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="amm-measurements"]',
        title: t('tour.addMeasureModal.step-measurements-title'),
        content: t('tour.addMeasureModal.step-measurements-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="amm-photos"]',
        title: t('tour.addMeasureModal.step-photos-title'),
        content: t('tour.addMeasureModal.step-photos-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="amm-footer"]',
        title: t('tour.addMeasureModal.step-footer-title'),
        content: t('tour.addMeasureModal.step-footer-content'),
        disableBeacon: true,
    },
];
